import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { ICreateScimConfigResponse } from '../service/ScimConfigService';

export function getScimConfigRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.27',
    httpMethod: 'GET',
    endpoint: `scimConfig?enabled=True`,
    serverWideRequest: false
  };
}

export function callGetScimConfigRequest(): Promise<ICreateScimConfigResponse> {
  return makeJsonRestApiRequest<null, ICreateScimConfigResponse>({
    config: getScimConfigRequestConfig(),
    request: null
  });
}